import React from "react";
import StockProductsPage from "../../../features/admin/stock-products/stock-products-page";

export default function StockProducts() {
  return <StockProductsPage />;
}
